export const pointsToLevel = (points: number) => {
    if (points >= 3000) {
        return 6;
    }
    if (points >= 25000) {
        return 5;
    }
    if (points >= 2000) {
        return 4;
    }
    if (points >= 1000) {
        return 3;
    }
    if (points >= 500) {
        return 2;
    }
    if (points >= 200) {
        return 1;
    }
    return 0;
};
